export const SET_MARKER = "Map - Set Marker";

export const setMarker = markers => {
  return { type: SET_MARKER, payload: markers };
};


// WEBPACK FOOTER //
// ./src/store/actions/marker.js